import { Injectable } from "@angular/core";

export const time = {
  day: 86400000,
  week: 604800000,
  hour: 3600000
};


@Injectable({ providedIn: 'root' })
export class GlobalVariablesService {
  user: any   // TODO - add interface?

  constructor() {}

  ngOnInit(){
  }

  setUserService(user) {
    this.user = user
  }


  getTarrif(){
    return this.user.settings.settings[0].items[0].value;
  }


}


